import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useDrop } from 'react-dnd'
import OrderCard from './OrderCardFullScreen'

export const ItemTypes = { ORDER: 'order' }

function OdlDropZone({ orders, moveOrderToList, isPastDate, selectedOrderIds, onToggleSelect, isOdlFullPage, children }) {
  const [{ canDrop }, drop] = useDrop({
    accept: ItemTypes.ORDER,
    drop: (item) => moveOrderToList(item),
    canDrop: () => !isPastDate,
    collect: (monitor) => ({
      canDrop: monitor.canDrop(),
    }),
  })

  const columns = isOdlFullPage ? 5 : 1

  return (
    <Box
      ref={drop}
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 1,
        alignContent: 'start',
        border: canDrop ? '2px dashed #b0b0b0' : '2px dashed transparent',
        borderRadius: '4px',
        transition: 'border-color 0.2s ease',
        minHeight: '100%',
      }}
    >
      {children && (
        <Box sx={{ height: '100%' }}>
          {children}
        </Box>
      )}
      {orders.map(({ node: deliveryOrder }) => (
        <OrderCard
          key={deliveryOrder.id}
          deliveryOrder={deliveryOrder}
          fromDriverId={null}
          isDragDisabled={isPastDate}
          selected={selectedOrderIds.has(deliveryOrder.id)}
          onToggleSelect={onToggleSelect}
        />
      ))}
    </Box>
  )
}

OdlDropZone.propTypes = {
  orders: PropTypes.array.isRequired,
  moveOrderToList: PropTypes.func.isRequired,
  isPastDate: PropTypes.bool.isRequired,
  selectedOrderIds: PropTypes.object.isRequired,
  onToggleSelect: PropTypes.func.isRequired,
  isOdlFullPage: PropTypes.bool,
  children: PropTypes.node,
}

export default OdlDropZone
